import React, { useCallback, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { languagesType, languagesWithIcons, shortLanguages } from 'shared/locale'

import { changeLang } from 'features/userSettings/actions'
import { selectLanguage } from 'features/userSettings/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import './MobileModalLang.scss'

const b = block('mobile-modal-lang')

const MobileModalLang: React.FC = () => {
  const dispatch = useDispatch()

  const lang = useSelector(selectLanguage, shallowEqual)

  const modalContext = useModalContext()

  const handleLangClick = useCallback(
    newLang => {
      dispatch(changeLang(newLang))
      modalContext.closeModal(MODAL_ROUTE_URLS.SET_LANGUAGE())()
    },
    [dispatch, modalContext],
  )

  const items = useMemo(
    () =>
      Object.values(languagesWithIcons)
        .map(item => (
          <div className={b('item', { active: lang === item.lang })} onClick={() => handleLangClick(item.lang)}>
            <img key={item.lang} src={item.icon} alt="" />
            {/* <span>{item.text}</span> */}
          </div>
        ))
        .filter(temp => temp),
    [lang, handleLangClick],
  )

  return <div className={b()}>{items}</div>
}

export default MobileModalLang
